import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { HomePage } from './home/home.page';
import { TranslocoModule } from '@ngneat/transloco';
import { AccountSettingsPage } from './account-settings/account-settings.page';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { OnboardingPage } from './onboarding/onboarding.page';
import { BusinessListPage } from './business-list-page/business-list-page';
import { LnrOktaCallbackPage } from './lnr-okta-callback/lnr-okta-callback.page';
import { LogoutPage } from './logout/logout.page';
import { FullPageLoadingModule } from '../full-page-loading/full-page-loading.module';
import { UploadMigrationPage } from './upload-migration/upload-migration.page';
import { CustomerDetailPage } from './customer-detail/customer-detail.page';
import { RewardsPage } from './rewards/rewards.page';
import { PagesRoutingModule } from './pages-routing.module';
import { FramedPage } from './framed-page.component';
import { DownloadReportsPage } from './download-reports/download-reports.page';
import { AddEditProductPage } from './add-edit-product/add-edit-product.page';
import { AddEditRewardPage } from './add-edit-reward/add-edit-reward.page';
import { VipSettingsPage } from './vip-settings/vip-settings-page.component';
import { SystemSettingsPage } from './system-settings/system-settings.page';
import { BusinessUnificationPage } from './business-unification/business-unification.page';

@NgModule({
  declarations: [
    HomePage,
    AccountSettingsPage,
    BusinessUnificationPage,
    SystemSettingsPage,
    OnboardingPage,
    BusinessListPage,
    LnrOktaCallbackPage,
    LogoutPage,
    UploadMigrationPage,
    CustomerDetailPage,
    RewardsPage,
    FramedPage,
    DownloadReportsPage,
    AddEditProductPage,
    AddEditRewardPage,
    VipSettingsPage,
  ],
  imports: [
    PagesRoutingModule,
    CommonModule,
    SharedModule,
    TranslocoModule,
    MatTabsModule,
    MatIconModule,
    FullPageLoadingModule,
  ],
})
/**
 * Module for pages
 */
export class PagesModule {}
